import { createTransform } from 'redux-persist';
import { CheckoutState, initialCheckoutState } from './slices/checkout.slice';

//const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const ONE_DAY_MS = 10000;

export const expireCheckoutItems24h = createTransform<
  CheckoutState,
  CheckoutState
>(
  (inbound) => {
    const byId: CheckoutState['byId'] = {};
    for (const [id, item] of Object.entries(inbound.byId)) {
      byId[id] = { ...item, _persistedAt: Date.now() };
    }
    return { ...inbound, byId };
  },

  (outbound) => {
    if (!outbound?.byId) return initialCheckoutState;

    const now = Date.now();
    const byId: CheckoutState['byId'] = {};
    for (const [id, item] of Object.entries(outbound.byId)) {
      const stamp = item._persistedAt ?? 0;
      if (now - stamp <= ONE_DAY_MS) {
        byId[id] = item;
      }
    }
    return { ...outbound, byId };
  },
  { whitelist: ['checkout'] },
);
